module.exports = __webpack_public_path__ + "static/media/A2_03.4e5a1324.png";